import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
  ViewChild,
  OnDestroy,
  Output,
  EventEmitter
} from "@angular/core";
import {
  BaseDataService,
  BaseUpdateComponent,
  DatePickerPopup2Component,
  ModalService,
  ModelDataService,
  QueryParameter,
  TabsContainerService,
  UserService,
  DropdownPicklistComponent,
  NotificationService
} from "yt-ng-framework";
import { PojedinacnaEvidencijaPdv } from "./pojedinacna-evidencija-pdv";
import { ActivatedRoute } from "@angular/router";
// import { NotificationsService } from "angular2-notifications";
import { TranslateService } from "@ngx-translate/core";

import { FakDokumentView } from "src/app/fak/faktura/fak-dokument-view";
import { NgbDate } from "@ng-bootstrap/ng-bootstrap";
import { List } from "immutable";
import { FakDokumentStavkaView } from "src/app/fak/faktura/fak-dokument-stavka-view";
import { FormGroup, Validators } from "@angular/forms";
import { FakDokument } from "src/app/fak/faktura/fak-dokument";
import { PojedinacnaEvidencijaPdvView } from "./pojedinacna-evidencija-pdv-view";
import { Observable, Subscription, forkJoin, of } from "rxjs";
import { FakDokumentPovezaniAvansi } from "src/app/fak/faktura/fak-dokument-povezani-avansi";
import { Period } from "../sifarnici/period";
import { FakDokumentPovezaniSaKOKZ } from "src/app/fak/faktura/fak-dokument-povezani-sa-kokz";
// import { ToastrService } from "ngx-toastr";

@Component({
  selector: "yt-pojedinacna-evidencija-pdv-update",
  templateUrl: "./pojedinacna-evidencija-pdv-update.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PojedinacnaEvidencijaPdvUpdateComponent
  extends BaseUpdateComponent<PojedinacnaEvidencijaPdv>
  implements OnInit, OnDestroy
{
  private activeTabSubscription: Subscription;

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected userService: UserService,
    protected baseDataService: BaseDataService,
    // protected notificationService: NotificationsService,
    protected toastrService: NotificationService,
    protected modalService: ModalService,
    protected translateService: TranslateService,
    protected modelDataService: ModelDataService,
    protected tabsContainerService: TabsContainerService<PojedinacnaEvidencijaPdv>,
    protected changeDetectorRef: ChangeDetectorRef
  ) {
    super(
      activatedRoute,
      baseDataService,
      toastrService,
      translateService,
      modalService
    );


  }

  parameterListTipDokumenta: List<QueryParameter> = List([]);
  parameterListRacun: List<QueryParameter> = List([]);
  // parameterListAvans: List<QueryParameter> = List([]);
  // parameterListKo: List<QueryParameter> = List([]);
  // parameterListKz: List<QueryParameter> = List([]);
  parameterListPeriod: List<QueryParameter> = List([]);
  parameterListSve: List<QueryParameter> = List([]);
  proveravajIzvorniDokument:boolean;
  showRacun: boolean = true;
  showAvansi: boolean = false;
  showKo: boolean = false;
  showKz: boolean = false;
  showSve: boolean = false;
  //isNew: boolean = true;
  tipDokumentaGenericName;
  poslednjiStatusGn;


  TableColumnsKomitent = [{name: "Naziv",label: "KOMITENT.NAZIV.SINGULAR",visible: true,canHide: false,width: "80%"}];

  TableColumnsFakDokum = [
    {name: "BrojDokumenta",label: "FAKDOKUMENT.BRDOK.SINGULAR",visible: true,canHide: false,width: "17%"},
    {name: "Datum",label: "FAKDOKUMENT.DATDOK.SINGULAR",type: "ngbDate",format: "dd.MM.yyyy",visible: true,canHide: false,width: "17%"},
    {name: "Komitent",label: "FAKDOKUMENT.KOMITENT.SINGULAR",visible: true,canHide: false,width: "17%"},
    {name: "KomitentMesto",label: "FAKDOKUMENT.KOMITENTMESTO.SINGULAR",visible: true,width: "17%",canHide: true},
    {name: "Ukupno",label: "FAKDOKUMENT.UKUPNO.SINGULAR",type: "number",visible: true,candHide: false,width: "17%"},
    {name: "VezanZaPpp",label: "FAKDOKUMENT.VEZANSAPPP.SINGULAR",visible: true,candHide: false,type: "boolean",aligment: 'center',width: "17%",tooltipName: 'VezanZaPppTooltip'},
  ];

  tipDokumentaItems;
  isVisible: boolean = false;
  
  @ViewChild("dropDownPickListComponent", { static: true }) dropDownPickListComponent: DropdownPicklistComponent<FakDokument>;
  @ViewChild("dtpDatumDokumenta", { static: true }) dtpDatumDokumenta: DatePickerPopup2Component;
  @Output() ColorEmiter = new EventEmitter();
  id: number;
  AvansUkupanPdvVisa: number = 0;
  AvansUkupanPdvNiza: number = 0;
  AvansBrojeviDokumenata: string = null;

  povezaniDokumenti=[
    {
      ID: 0,
      Name: 'Nema veze sa dokumentima'
    },
    {
      ID: 1,
      Name: 'Veza sa računom'
    },
    {
      ID: 2,
      Name: 'Za period'
    },
    {
      ID: 3,
      Name: 'Veza sa avansom'
    }
  ];

  ngOnInit() {
    super.ngOnInit();

    this.baseFormGroup.get("PravacDokumentaId").disable();
    this.baseFormGroup.get("PravacDokumentaId").updateValueAndValidity();

    this.baseFormGroup.get("PeriodId").disable();
    this.baseFormGroup.get("PeriodId").updateValueAndValidity();

    this.baseFormGroup.get("FakDokumMasterDokumID").disable();
    this.baseFormGroup.get("FakDokumMasterDokumID").updateValueAndValidity();

    this.baseFormGroup.get("OsnovicaPdvStopa10").disable();
    this.baseFormGroup.get("OsnovicaPdvStopa10").updateValueAndValidity();

    this.baseFormGroup.get("OsnovicaPdvStopa20").disable();
    this.baseFormGroup.get("OsnovicaPdvStopa20").updateValueAndValidity();

    this.baseFormGroup.get("ObracunatiPdv").disable();
    this.baseFormGroup.get("ObracunatiPdv").updateValueAndValidity();

    this.baseFormGroup.get("ObracunatiPdvStopa10").disable();
    this.baseFormGroup.get("ObracunatiPdvStopa10").updateValueAndValidity();

    this.baseFormGroup.get("ObracunatiPdvStopa20").disable();
    this.baseFormGroup.get("ObracunatiPdvStopa20").updateValueAndValidity();

    this.baseFormGroup.get("UkupanIznosNaknade").disable();
    this.baseFormGroup.get("UkupanIznosNaknade").updateValueAndValidity();

    this.baseFormGroup.get("DatumDokumenta").disable();
    this.baseFormGroup.get("DatumDokumenta").updateValueAndValidity();

    this.baseFormGroup.get("Godina").disable();
    this.baseFormGroup.get("Godina").updateValueAndValidity();

    this.baseFormGroup.get("KomitentID").disable();
    this.baseFormGroup.get("KomitentID").updateValueAndValidity();

    this.baseFormGroup.get("IdentifikatorPosiljaoca").disable();
    this.baseFormGroup.get("IdentifikatorPosiljaoca").updateValueAndValidity();

    this.baseFormGroup.get("BrojPovezanogDokumenta").disable();
    this.baseFormGroup.get("BrojPovezanogDokumenta").updateValueAndValidity();

    this.baseFormGroup.get("DatumObracuna").disable();
    this.baseFormGroup.get("DatumObracuna").updateValueAndValidity();

    this.baseFormGroup.get("OsnovZaAvansnoPlacanje").disable();
    this.baseFormGroup.get("OsnovZaAvansnoPlacanje").updateValueAndValidity();

    this.baseFormGroup.get("DatumPlacanja").disable();
    this.baseFormGroup.get("DatumPlacanja").updateValueAndValidity();

    this.baseFormGroup.get("RelatedDocuments").disable();
    this.baseFormGroup.get("RelatedDocuments").updateValueAndValidity();

    this.disabledControlsState = this.mapDisabledState(this.baseFormGroup);

    this.addValidatorToFc("Godina",Validators.required,"required","POJEDINACNAEVIDENCIJAPDV.GODINA.VALIDATION.REQUIRED");
    this.addValidatorToFc("IdentifikatorPosiljaoca",Validators.required,"required","POJEDINACNAEVIDENCIJAPDV.IDENTIFIKATORPOSILJAOCA.VALIDATION.REQUIRED");
    this.addValidatorToFc("PoreskiPeriodId",Validators.required,"required","POJEDINACNAEVIDENCIJAPDV.PORESKIPERIOD.VALIDATION.REQUIRED");
    this.addValidatorToFc("TipDokumentaSefId",Validators.required,"required","POJEDINACNAEVIDENCIJAPDV.TIPDOKUMENTA.VALIDATION.REQUIRED");
    this.addValidatorToFc("PeriodId",Validators.required,"required","POJEDINACNAEVIDENCIJAPDV.PERIOD.VALIDATION.REQUIRED");

    //zadržavanje postojećih sinhronih validatora
    // const currentValidators1 = this.baseFormGroup.validator ? this.baseFormGroup.validator : null;
    this.baseFormGroup.setValidators( checkPovezaniDokumenti('RelatedInvoiceOption',this));
    this.baseFormGroup.updateValueAndValidity();


    if (this.parameterListTipDokumenta && this.parameterListTipDokumenta.size == 0) {
      this.parameterListTipDokumenta = this.parameterListTipDokumenta.push(
        new QueryParameter("prometID", "-1")
      );
    }

    if (this.parameterListPeriod && this.parameterListPeriod.size == 0) {
      this.parameterListPeriod = this.parameterListPeriod.push(
        new QueryParameter("poreskiPeriodID", "1")
      );
    }


    this.parameterListRacun = this.parameterListRacun.push(
      new QueryParameter('pojedinacnaId', -1),
      new QueryParameter('genericName', 'iz_fakt')
    );

     this.IDProcessed.subscribe((value) => {
      this.id = this.Item.ID;
      this.AvansUkupanPdvNiza = 0;
      this.AvansUkupanPdvVisa = 0;

      this.poslednjiStatusGn = this.Item.StatusGenericName;

      this.activeTabSubscription=this.tabsContainerService.ActiveTab.subscribe(activeTab => {
        if(activeTab === 'tbUpdate') {
            // Logika kada je aktivan tab onaj saa 'tbUpdate' ID
          this.proveravajIzvorniDokument=true;
        }
      }); 

      if (value && this.Item.ID == -1) {
        
        this.vrednostPovezanogDokumenta = null;
      //  this.parameterListTipDokumenta = List([]);
      //   this.parameterListPeriod = List([]);
      //   this.parameterListRacun = List([]);

      //   this.parameterListTipDokumenta = this.parameterListTipDokumenta.push(
      //     new QueryParameter("prometID", "-1")
      //   );
      //   this.parameterListPeriod = this.parameterListPeriod.push(
      //     new QueryParameter("poreskiPeriodID", "-1")
      //   );
      //   this.parameterListRacun = this.parameterListRacun.push(
      //     new QueryParameter('pojedinacnaId', -1),
      //     new QueryParameter('genericName', 'iz_fakt')
      //   )
      } else if(value && this.Item.ID != -1){
        //ukoliko je postojeći dokument, uzimaju se podaci o avansima
          this.prikupiPodatkeOAvansima(this.Item.FakDokumMasterDokumID);
          
          //ukoliko je postojeći da vrati vezu sa računima ili datumima
          // if (this.tipDokumentaGenericName == "CreditNote" || this.tipDokumentaGenericName == "DebitNote"){
          //   this.prikupiPodatkeODokumentimaZaKOKZ(this.Item.FakDokumMasterDokumID);
          //   if (this.brojDokumenta){
          //     this.baseFormGroup.get('RelatedDocuments').setValue(this.brojDokumenta);
          //     this.baseFormGroup.get('RelatedDocuments').updateValueAndValidity();
          //   }
          // }


          //08.12.2023, 15.12.2023
          setTimeout(() => {
            if (this.proveravajIzvorniDokument)
            this.proveriDaLiPostojiRazlikaUVrednostimaElemenataIzvornogDokumenta();
          }, 100);

          this.baseFormGroup.get("TipDokumentaSefId").disable();
          this.baseFormGroup.get("TipDokumentaSefId").updateValueAndValidity();

          this.vrednostPovezanogDokumenta = this.Item.RelatedInvoiceOption;

        }
        
     });

    this.ItemSaved.subscribe((data: PojedinacnaEvidencijaPdvView) => {
      this.baseDataService
        .GetByID(this.modelData.MainList.ModelName,data.ID,this.modelData.MainList.ModelClass)
          .subscribe((pojedinacnaEvidencaPdv: PojedinacnaEvidencijaPdv) => {
            this.Item = pojedinacnaEvidencaPdv;
            this.baseFormGroup.patchValue(this.Item);
            this.SavedItem = this.baseFormGroup.getRawValue();
            this.dropDownPickListComponent.loadItems();
            this.ColorEmiter.emit(data.StatusColor);
            //ubačena provera da li je korigovan da ne bi zaključao na "X"
            if(this.poslednjiStatusGn === "20")
              this.LockUnLockService().subscribe(()=>{})
          });

        this.baseFormGroup.get("TipDokumentaSefId").disable();
        this.baseFormGroup.get("FakDokumMasterDokumID").disable();      
    });
  }

  ngOnDestroy(){
    super.ngOnDestroy();
    this.activeTabSubscription.unsubscribe();
  }



  // pamtiVrednostTipDokumentaSefID: number;
  // pamtiVrednostPravacDokumentaID: number;
  onPravacDokumentaSelect(event) {
    if (event) {
      let prometID: QueryParameter = new QueryParameter();
      this.parameterListTipDokumenta = List([]);
      prometID.Name = "prometID";
      prometID.Value = event.ID;
      this.parameterListTipDokumenta = this.parameterListTipDokumenta.push(prometID);
      if (this.Item.ID == -1)
        this.SavedItem = this.baseFormGroup.getRawValue();
    }

      
  }

  pamtiVrednostTipDokumentaSefID: number;
  onTipDokumentaSelect(event) {

    if (event) {
      this.tipDokumentaGenericName = event.GenericName;
      if (this.pamtiVrednostTipDokumentaSefID && this.pamtiVrednostTipDokumentaSefID != event.ID && this.Item.ID==-1) 
      {
        this.resetVrednosti();
      }


        switch (event.GenericName) {
          case "Invoice": {
            // this.showRacun = true;
            // this.showAvansi = false;
            // this.showKo = false;
            // this.showKz = false;
            // this.showSve = false;
            this.parameterListRacun = List([]);
            this.parameterListRacun = this.parameterListRacun.push(
              new QueryParameter('pojedinacnaId', this.Item.ID),
              new QueryParameter('genericName', 'iz_fakt')
            )

            this.povezaniDokumenti=[
              {
                ID: 0,
                Name: 'Nema veze sa dokumentima'
              },              
              {
                ID: 3,
                Name: 'Veza sa avansom'
              }
            ];
            this.baseFormGroup.get('RelatedInvoiceOption').setValue(this.Item.RelatedInvoiceOption)

            break;
          }
          case "PrepaymentInvoice": {
            // this.showRacun = false;
            // this.showAvansi = true;
            // this.showKo = false;
            // this.showKz = false;
            // this.showSve = false;
            this.parameterListRacun = List([]);
            this.parameterListRacun = this.parameterListRacun.push(
              new QueryParameter('pojedinacnaId', this.Item.ID),
              new QueryParameter('genericName', 'iz_avans')
            )
            this.povezaniDokumenti=[];


            break;
          }
          case "CreditNote": {
            // this.showRacun = false;
            // this.showAvansi = false;
            // this.showKo = true;
            // this.showKz = false;
            // this.showSve = false;
            this.parameterListRacun = List([]);
            this.parameterListRacun = this.parameterListRacun.push(
              new QueryParameter('pojedinacnaId', this.Item.ID),
              new QueryParameter('genericName', 'ko')
            )
            this.povezaniDokumenti=[
              {
                ID: 1,
                Name: 'Veza sa računom'
              },
              {
                ID: 2,
                Name: 'Za period'
              },
              {
                ID: 3,
                Name: 'Veza sa avansom'
              }
            ];
            break;
          }
          case "DebitNote": {
            // this.showRacun = false;
            // this.showAvansi = false;
            // this.showKo = false;
            // this.showKz = true;
            // this.showSve = false;
            this.parameterListRacun = List([]);
            this.parameterListRacun = this.parameterListRacun.push(
              new QueryParameter('pojedinacnaId', this.Item.ID),
              new QueryParameter('genericName', 'kz')
            )
            this.povezaniDokumenti=[
             
              {
                ID: 1,
                Name: 'Veza sa računom'
              },
              {
                ID: 2,
                Name: 'Za period'
              },
             
            ];
            break;
          }
      }


      this.pamtiVrednostTipDokumentaSefID = event.ID;

      if(this.Item.ID == -1)
      this.baseFormGroup.get('FakDokumMasterDokumID').enable();

    }
  }


  onFakDokumentSelect(event: FakDokumentView) {
    if (event) {
      this.baseFormGroup.patchValue({ BrojDokumenta: event.BrojDokumenta });
      this.baseFormGroup.get("BrojDokumenta").updateValueAndValidity();
      var datum = new Date();

      //Kreira se broj obracuna
      if (this.Item.ID == -1){
        this.baseFormGroup.patchValue({BrojObracuna: "0" + (datum.getMonth() + 1) + " - " + event.BrojDokumenta});
              //Datum obracuna
      let dateNow = new Date();
      let date: NgbDate = new NgbDate(
        dateNow.getFullYear(),
        dateNow.getMonth() + 1,
        dateNow.getDate()
      );
      this.baseFormGroup.patchValue({ DatumObracuna: date });
      this.baseFormGroup.get("DatumObracuna").updateValueAndValidity();

      this.baseFormGroup.patchValue({ DatumObracuna: date });
      this.baseFormGroup.get("DatumDokumenta").updateValueAndValidity();

      }



      //nov metod kojem se prosledjuje masterdokum, na serversu se odredjuje id koji vraca stavke za dati id 
      //i vraca podatke za avanse
      this.prikupiPodatkeOAvansima(event.ID);

      //da vrati vezu sa računima ako biraju KO/KZ za v3.9
      if (this.tipDokumentaGenericName == "CreditNote" || this.tipDokumentaGenericName == "DebitNote")
        this.prikupiPodatkeODokumentimaZaKOKZ(event.ID);

      
      //ukoliko je tip dokumenta avans, onda se uzimaju podaci ponude/predracuna
      if(this.tipDokumentaGenericName == "PrepaymentInvoice"){
        this.baseFormGroup.get("OsnovZaAvansnoPlacanje").enable();
        this.baseFormGroup.get("OsnovZaAvansnoPlacanje").updateValueAndValidity();
      this.baseDataService.Get("FakDokument", "DajPovezaneDokumenteZaAvans",[new QueryParameter("id", event.ID)], null)
          .subscribe(data => {
            if(data){
              this.baseFormGroup.patchValue({OsnovZaAvansnoPlacanje: data});
              this.baseFormGroup.get("OsnovZaAvansnoPlacanje").updateValueAndValidity();
            }
          })
        }
    }
  }

  uveziVrednostiIzvornogDokumenta(){
    let mastedDokumID=this.baseFormGroup.get("FakDokumMasterDokumID").value
    
    let postojeciBrojPovezanogAv = this.SavedItem['BrojPovezanogDokumenta'];

    if(postojeciBrojPovezanogAv == null)
      postojeciBrojPovezanogAv = this.AvansBrojeviDokumenata;

    let godina : number = Number(this.baseFormGroup.get('Godina').value);
    let poreskiPeriodId : number = Number(this.baseFormGroup.get('PoreskiPeriodId').value);
    let periodId : number = Number(this.baseFormGroup.get('PeriodId').value);

    // //Sneža, ako je po novom od 01.09.2024 da ne popuni polje povezani dokument
    // if ((godina >= 2024 && poreskiPeriodId==1 && periodId>=9) || (godina >= 2024 && poreskiPeriodId==2 && periodId>=15) || godina > 2024 ){
    //     postojeciBrojPovezanogAv = "";
    // }

    if(mastedDokumID){
    forkJoin([this.baseDataService.Get("FakDokumentStavka", "GetByFakDokumentMasterDokumID", [new QueryParameter("fakDokumentMasterDokumID", mastedDokumID)],FakDokumentStavkaView),
             this.baseDataService.Get("FakDokument", "GetBymasterDokumID", [new QueryParameter("masterDokumID", mastedDokumID)], FakDokument)])
    .subscribe((data) => {
      if(data){
        this.stavkeDokumenta = data[0];
        this.zaglavljeDokumenta = data[1];

        let komitentId;
        let datum;
        let osnovicaPdv20 = 0;
        let osnovicaPdv10 = 0;
        let pdvIznos20 = 0;
        let pdvIznos10 = 0;
        let datumPrometaDo;
        let datumPlacanja;
        let godina;

        if(this.zaglavljeDokumenta){
          komitentId = this.zaglavljeDokumenta[0].KomitentID;
          datum = this.zaglavljeDokumenta[0].Datum;
          datumPrometaDo = this.zaglavljeDokumenta[0].DatumPrometaDo;
          datumPlacanja = this.zaglavljeDokumenta[0].DatDpo;

          if(!datumPrometaDo)
            datumPrometaDo = datum;
          //ukoliko je tip dokumenta avans, za godinu i datum placanja se postavljaju vrednosti datuma placanja sa avansa,
          //u suprotnom postavljaju se vrednosti datuma do sa izornog dokumenta
          if(this.tipDokumentaGenericName == "PrepaymentInvoice"){
            godina = datumPlacanja.year;
            this.baseFormGroup.patchValue({Godina: datumPlacanja.year});
            this.baseFormGroup.get("Godina").updateValueAndValidity();
            this.baseFormGroup.patchValue({DatumPlacanja: datumPlacanja});
            this.baseFormGroup.get("DatumPlacanja").updateValueAndValidity();
          }else{
            if(datumPrometaDo){
              godina = datumPrometaDo.year;
              this.baseFormGroup.patchValue({Godina: datumPrometaDo.year});
              this.baseFormGroup.get("Godina").updateValueAndValidity();
            }
            // //ukoliko ne postoji datumdo javlja se greška
            // else{
            //   this.translateService.get(['POJEDINACNAEVIDENCIJAPDV.NEDOSTAJEDATUMDO.WARNING'])
            //   .subscribe(translate => {
            //       alert(translate['POJEDINACNAEVIDENCIJAPDV.NEDOSTAJEDATUMDO.WARNING']);
            //       return;
            //   });
            // }
          }
        }

        if (this.stavkeDokumenta && this.zaglavljeDokumenta) {
          this.stavkeDokumenta.forEach((element) => {
            if (element.Tarifa == "Viša tarifa") {
              osnovicaPdv20 += element.OsnovicaStavke;
              pdvIznos20 += element.PdvStavke;
            }
  
            if (element.Tarifa == "Niža tarifa") {
              osnovicaPdv10 += element.OsnovicaStavke;
              pdvIznos10 += element.PdvStavke;
            }
          });

          pdvIznos20 = pdvIznos20 - this.AvansUkupanPdvVisa;
          pdvIznos10 = pdvIznos10 - this.AvansUkupanPdvNiza;
        }

        this.popuniVrednostimaIzvornogDokumenta(
          osnovicaPdv20
          , osnovicaPdv10
          , pdvIznos20
          , pdvIznos10
          , komitentId
          , datum
          , datumPlacanja
          , godina
          , postojeciBrojPovezanogAv
        );
        
      }

    });  
  }      

  }

  zaglavljeDokumenta;
  stavkeDokumenta;
  proveriDaLiPostojiRazlikaUVrednostimaElemenataIzvornogDokumenta()
  {
    let mastedDokumID=this.baseFormGroup.get("FakDokumMasterDokumID").value;
    let osnovica10 = this.baseFormGroup.get("OsnovicaPdvStopa10").value;
    let osnovica20 = this.baseFormGroup.get("OsnovicaPdvStopa20").value;
    let pdv10 = this.baseFormGroup.get("ObracunatiPdvStopa10").value;
    let pdv20 = this.baseFormGroup.get("ObracunatiPdvStopa20").value;
    let komitentID = this.baseFormGroup.get("KomitentID").value;
    let datumDokumenta = this.baseFormGroup.get("DatumDokumenta").value;
    let datumPlacanja = this.baseFormGroup.get("DatumPlacanja").value;
    let godina = this.baseFormGroup.get("Godina").value;
    let brojPovezanogDokumenta = this.baseFormGroup.get("BrojPovezanogDokumenta").value;

    if (mastedDokumID==null)
      return;

    forkJoin([this.baseDataService.Get("FakDokumentStavka", "GetByFakDokumentMasterDokumID", [new QueryParameter("fakDokumentMasterDokumID", mastedDokumID)],FakDokumentStavkaView),
             this.baseDataService.Get("FakDokument", "GetBymasterDokumID", [new QueryParameter("masterDokumID", mastedDokumID)], FakDokument)])
    .subscribe((data) => {
      if(data){
        this.stavkeDokumenta = data[0];
        this.zaglavljeDokumenta = data[1];
      }

      let osnovicaPdv20 = 0;
      let osnovicaPdv10 = 0;
      let pdvIznos20 = 0;
      let pdvIznos10 = 0;
      let komitentId;
      let datum;
      let datumPl;
      let lc_godina;
      let set: boolean = false;

      if(this.stavkeDokumenta == null){
        osnovicaPdv20 = 0;
        osnovicaPdv10 = 0;
        pdvIznos20 = 0;
        pdvIznos10 = 0;
      }

      if (this.stavkeDokumenta) { 
        this.stavkeDokumenta.forEach((element) => {
          if (element.Tarifa == "Viša tarifa") {
            osnovicaPdv20 += element.OsnovicaStavke;
            pdvIznos20 += element.PdvStavke;
          }

          if (element.Tarifa == "Niža tarifa") {
            osnovicaPdv10 += element.OsnovicaStavke;
            pdvIznos10 += element.PdvStavke;
          }
        });
      

        pdvIznos20 = pdvIznos20 - this.AvansUkupanPdvVisa;
        pdvIznos10 = pdvIznos10 - this.AvansUkupanPdvNiza;
      }

        if( this.zaglavljeDokumenta){
        komitentId = this.zaglavljeDokumenta[0].KomitentID;
        datum = this.zaglavljeDokumenta[0].Datum;

        if(this.tipDokumentaGenericName == "PrepaymentInvoice"){
          lc_godina = this.zaglavljeDokumenta[0].DatDpo.year;
          datumPl = this.zaglavljeDokumenta[0].DatDpo;
          var sameDatumPlacanja = compareNgbDates(datumPlacanja, datumPl)
        }else{
          lc_godina = this.zaglavljeDokumenta[0].DatumPrometaDo ? this.zaglavljeDokumenta[0].DatumPrometaDo.year : this.zaglavljeDokumenta[0].Datum.year;
          var sameDatumPlacanja = true;
        }
        
        

        

        var sameDate = compareNgbDates(datumDokumenta, datum)
        



      }
      if (osnovicaPdv10!=osnovica10
        || osnovicaPdv20!=osnovica20
        || pdvIznos10!=pdv10
        || pdvIznos20!=pdv20
        || komitentId != komitentID
        || !sameDate
        || !sameDatumPlacanja
        || godina != lc_godina
        || brojPovezanogDokumenta != this.AvansBrojeviDokumenata
  
        )
        {
          if(this.Item.StatusGenericName ==="20")
            set = confirm("Ima promena u izvornom dokumentu koje se odnose na ovu pojedinačnu prijavu. Aplikacija će uvesti nove podatke sa izvornog dokumenta, nakon čega je potrebno ponovo snimiti pojedinačnu prijavu. Da li ponovo da uvezemo podatke?");
          else 
            set = confirm("Ima promena u izvornom dokumentu koje se odnose na ovu pojedinačnu prijavu. Aplikacija će uvesti nove podatke sa izvornog dokumenta, nakon čega je potrebno ponovo snimiti pojedinačnu prijavu. Ukoliko je ova prijava već slata na SEF, potrebno ju je ponovo poslati. Da li ponovo da uvezemo podatke?");
        }
  
  
        if (set)
        {
          this.popuniVrednostimaIzvornogDokumenta(
            osnovicaPdv20
            , osnovicaPdv10
            , pdvIznos20
            , pdvIznos10
            , komitentId
            , datum
            , datumPl
            , lc_godina
            , this.AvansBrojeviDokumenata
          );

          if(set && this.Item.StatusGenericName ==="20"){
            this.baseDataService.Get('PojedinacnaEvidencijaPdv','AzurirajPepdv', [new QueryParameter('ID', this.Item.ID),new QueryParameter('edokumentID', this.Item.EdokumentID),new QueryParameter('masterDokumID', this.Item.MasterDokumID)],PojedinacnaEvidencijaPdvView)
              .subscribe((data: PojedinacnaEvidencijaPdvView[]) => {}
              ,error => {
                throw error;       
              }
              );
          }
        }
     });        



  }

  

  popuniVrednostimaIzvornogDokumenta(
    osnovicaPdv20: number
    , osnovicaPdv10: number
    , pdvIznos20: number
    , pdvIznos10:number
    , komitentId: number
    , datumDokumenta: Date
    , datumPlacanja: NgbDate
    , lc_godina: number
    , brojPovezanogDokumenta: string
  )
  {
    let ukupanObracunatiPdv = pdvIznos20 + pdvIznos10;
    let ukupanIznosOsnovice = osnovicaPdv20 + osnovicaPdv10;
    //Sneža, dodala pdv sa avansa
    let ukupanIznosNaknade =  ukupanIznosOsnovice + ukupanObracunatiPdv + this.AvansUkupanPdvNiza + this.AvansUkupanPdvVisa;
    let postojeciOpis20 =this.baseFormGroup.get("OpisPrometaStopa20").value;
    let postojeciOpis10 =this.baseFormGroup.get("OpisPrometaStopa10").value;

    if(this.Item.ID == -1){
      if(osnovicaPdv20!=0 ){
        this.baseFormGroup.patchValue({OpisPrometaStopa20: 'Opis prometa po 20%'});
        this.baseFormGroup.get("OpisPrometaStopa20").updateValueAndValidity();
      }else{
        this.baseFormGroup.patchValue({OpisPrometaStopa20: null});
        this.baseFormGroup.get("OpisPrometaStopa20").updateValueAndValidity();
      }
    

    if(osnovicaPdv10!=0){
      this.baseFormGroup.patchValue({OpisPrometaStopa10: 'Opis prometa po 10%'});
      this.baseFormGroup.get("OpisPrometaStopa10").updateValueAndValidity();
    }else{
      this.baseFormGroup.patchValue({OpisPrometaStopa10: null});
      this.baseFormGroup.get("OpisPrometaStopa10").updateValueAndValidity();
    }
  }else{
    if(postojeciOpis20 == null){
      if(osnovicaPdv20!=0 ){
        this.baseFormGroup.patchValue({OpisPrometaStopa20: 'Opis prometa po 20%'});
        this.baseFormGroup.get("OpisPrometaStopa20").updateValueAndValidity();
      }else{
        this.baseFormGroup.patchValue({OpisPrometaStopa20: null});
        this.baseFormGroup.get("OpisPrometaStopa20").updateValueAndValidity();
      }
    }

    if(postojeciOpis10 == null){
      if(osnovicaPdv10!=0){
        this.baseFormGroup.patchValue({OpisPrometaStopa10: 'Opis prometa po 10%'});
        this.baseFormGroup.get("OpisPrometaStopa10").updateValueAndValidity();
      }else{
        this.baseFormGroup.patchValue({OpisPrometaStopa10: null});
        this.baseFormGroup.get("OpisPrometaStopa10").updateValueAndValidity();
      }
    }
  }

    this.baseFormGroup.patchValue({OsnovicaPdvStopa20: osnovicaPdv20});
    this.baseFormGroup.get("OsnovicaPdvStopa20").updateValueAndValidity();

    this.baseFormGroup.patchValue({OsnovicaPdvStopa10: osnovicaPdv10});
    this.baseFormGroup.get("OsnovicaPdvStopa10").updateValueAndValidity();

    this.baseFormGroup.patchValue({ObracunatiPdvStopa20: pdvIznos20});
    this.baseFormGroup.get("ObracunatiPdvStopa20").updateValueAndValidity();

    this.baseFormGroup.patchValue({ObracunatiPdvStopa10: pdvIznos10});
    this.baseFormGroup.get("ObracunatiPdvStopa10").updateValueAndValidity();

    this.baseFormGroup.patchValue({UkupanIznosNaknade: ukupanIznosNaknade});
    this.baseFormGroup.get("UkupanIznosNaknade").updateValueAndValidity();

    this.baseFormGroup.patchValue({ObracunatiPdv: ukupanObracunatiPdv});
    this.baseFormGroup.get("ObracunatiPdv").updateValueAndValidity();

    this.baseFormGroup.patchValue({UkupanIznosOsnovice: ukupanIznosOsnovice});
    this.baseFormGroup.get("UkupanIznosOsnovice").updateValueAndValidity();

    this.baseFormGroup.patchValue({KomitentID: komitentId});
    this.baseFormGroup.get("KomitentID").updateValueAndValidity();

    this.baseFormGroup.patchValue({DatumDokumenta: datumDokumenta});
    this.baseFormGroup.get("DatumDokumenta").updateValueAndValidity();

    this.baseFormGroup.patchValue({BrojPovezanogDokumenta: brojPovezanogDokumenta});
    this.baseFormGroup.get("BrojPovezanogDokumenta").updateValueAndValidity();

    if(this.tipDokumentaGenericName == "PrepaymentInvoice"){
      this.baseFormGroup.patchValue({DatumPlacanja: datumPlacanja});
      this.baseFormGroup.get("DatumPlacanja").updateValueAndValidity();
      
      this.baseFormGroup.patchValue({Godina: datumPlacanja.year})
      this.baseFormGroup.get("Godina").updateValueAndValidity();
    }else{
      this.baseFormGroup.patchValue({Godina: lc_godina})
      this.baseFormGroup.get("Godina").updateValueAndValidity();
    }

  }

  onKomitentSelect(event) {
    if (event) {
      if (event.Pib && event.MaticniBroj) {
        this.baseFormGroup.patchValue({ IdentifikatorPosiljaoca: event.Pib });
        this.baseFormGroup
          .get("IdentifikatorPosiljaoca")
          .updateValueAndValidity();
      } else {
        this.baseFormGroup.patchValue({ IdentifikatorPosiljaoca: event.Jmbg });
        this.baseFormGroup
          .get("IdentifikatorPosiljaoca")
          .updateValueAndValidity();
      }
    }
  }

  pamtiVrednostPoreskiPeriodID: number;

  onPoreskiPeriodSelect(event) {
    const formDirty = this.baseFormGroup.dirty;
  
    if (event && (this.pamtiVrednostPoreskiPeriodID !== event.ID || !formDirty)) {
      if (this.pamtiVrednostPoreskiPeriodID && formDirty) {
        this.baseFormGroup.patchValue({ PeriodId: null });
        this.baseFormGroup.get('PeriodId').updateValueAndValidity();
      }
      if (this.pamtiVrednostPoreskiPeriodID !== event.ID) {
        let poreskiPeriodID: QueryParameter = new QueryParameter();
        this.parameterListPeriod = List([]);
        poreskiPeriodID.Name = 'poreskiPeriodID';
        poreskiPeriodID.Value = event.ID;
        this.parameterListPeriod = this.parameterListPeriod.push(poreskiPeriodID);
      }
  
      this.pamtiVrednostPoreskiPeriodID = event.ID;


    }
    this.baseFormGroup.get('PeriodId').enable();
  }
  

  resetVrednosti() {
    let datum = new Date();
    this.baseFormGroup.patchValue({ FakDokumMasterDokumID: null });
    this.baseFormGroup.get("FakDokumMasterDokumID").updateValueAndValidity();
    this.baseFormGroup.patchValue({ BrojDokumenta: null });
    this.baseFormGroup.get("BrojDokumenta").updateValueAndValidity();
    this.baseFormGroup.patchValue({ BrojObracuna: null });
    this.baseFormGroup.get("BrojObracuna").updateValueAndValidity();
    this.baseFormGroup.patchValue({ KomitentID: null });
    this.baseFormGroup.get("KomitentID").updateValueAndValidity();
    this.baseFormGroup.patchValue({ IdentifikatorPosiljaoca: null });
    this.baseFormGroup.get("IdentifikatorPosiljaoca").updateValueAndValidity();
    this.baseFormGroup.patchValue({ DatumDokumenta: null });
    this.baseFormGroup.get("DatumDokumenta").updateValueAndValidity();
    this.baseFormGroup.patchValue({ OsnovicaPdvStopa20: null });
    this.baseFormGroup.get("OsnovicaPdvStopa20").updateValueAndValidity();
    this.baseFormGroup.patchValue({ OsnovicaPdvStopa10: null });
    this.baseFormGroup.get("OsnovicaPdvStopa10").updateValueAndValidity();
    this.baseFormGroup.patchValue({ ObracunatiPdvStopa20: null });
    this.baseFormGroup.get("ObracunatiPdvStopa20").updateValueAndValidity();
    this.baseFormGroup.patchValue({ ObracunatiPdvStopa10: null });
    this.baseFormGroup.get("ObracunatiPdvStopa10").updateValueAndValidity();
    this.baseFormGroup.patchValue({ UkupanIznosNaknade: null });
    this.baseFormGroup.get("UkupanIznosNaknade").updateValueAndValidity();
    this.baseFormGroup.patchValue({ ObracunatiPdv: null });
    this.baseFormGroup.get("ObracunatiPdv").updateValueAndValidity();
    this.baseFormGroup.patchValue({ OsnovZaAvansnoPlacanje: null });
    this.baseFormGroup.get("OsnovZaAvansnoPlacanje").updateValueAndValidity();
    this.baseFormGroup.patchValue({ BrojPovezanogDokumenta: null });
    this.baseFormGroup.get("BrojPovezanogDokumenta").updateValueAndValidity();
    this.baseFormGroup.patchValue({ DatumPlacanja: null });
    this.baseFormGroup.get("DatumPlacanja").updateValueAndValidity();
    this.baseFormGroup.patchValue({ Godina: datum.getFullYear() });
    this.baseFormGroup.get("Godina").updateValueAndValidity();
   }

   prikupiPodatkeOAvansima(masterDokumID){
        //prikupljanje podataka o avansima
        this.baseDataService.Get("FakDokument","DajAvanseZaFakDokument",[new QueryParameter("id", masterDokumID)], FakDokumentPovezaniAvansi)
        .subscribe((data: FakDokumentPovezaniAvansi[]) => {
          this.AvansBrojeviDokumenata = null;
          this.AvansUkupanPdvVisa = 0;
          this.AvansUkupanPdvNiza = 0;
          if(data){
            let brojAvansa: string = "";
            
            data.forEach(element => {
              brojAvansa += element.BrojDokumenta + "; ";
              this.AvansUkupanPdvVisa += element.UkPdvVisa;
              this.AvansUkupanPdvNiza += element.UkPdvNiza;
            })
            brojAvansa = brojAvansa.slice(0,-2)
            this.AvansBrojeviDokumenata = brojAvansa;
            
          }
            if (this.id && this.id == -1) {
              this.uveziVrednostiIzvornogDokumenta();
            }
          }
        )
   }

   brojDokumenta: string = null;
   datumPrometaOd: Date = null;
   datumPrometaDo: Date = null;

   prikupiPodatkeODokumentimaZaKOKZ(id: number){
    this.baseDataService.Get("FakDokument","DajPovezaneDokumentaSaKOKZ",[new QueryParameter("id", id)], FakDokumentPovezaniSaKOKZ)
    .subscribe((data: FakDokumentPovezaniSaKOKZ[]) => {

      if (data){
        let duzinaData: number = data.length;
        this.brojDokumenta = "";
        this.datumPrometaOd = null;
        this.datumPrometaDo = null;
        data.forEach(element => {
          if(element.BrojDokumenta != null)
            this.brojDokumenta += element.BrojDokumenta + "; ";
          else{
            this.datumPrometaOd = element.DatumPrometaOd;
            this.datumPrometaDo = element.DatumPrometaDo;
          }
        })
        this.brojDokumenta = this.brojDokumenta.slice(0,-2);
      }

    })
   }

   vrednostPovezanogDokumenta: number = null;
   OnPovezaniDokumentiSelect(value){
    if(value){
      //if (this.Item.ID == -1){
        this.vrednostPovezanogDokumenta = value.ID;
        switch(value.ID){
          case 0:{
            this.baseFormGroup.get('RelatedInvoiceIssueDateFrom').setValue(null);
            this.baseFormGroup.get('RelatedInvoiceIssueDateFrom').updateValueAndValidity();
            this.baseFormGroup.get('RelatedInvoiceIssueDateTo').setValue(null);
            this.baseFormGroup.get('RelatedInvoiceIssueDateTo').updateValueAndValidity();
            this.baseFormGroup.get('RelatedVatRecords').setValue(null);
            this.baseFormGroup.get('RelatedVatRecords').updateValueAndValidity();
            this.baseFormGroup.get('RelatedVatRecordOutOfSystem').setValue(null);
            this.baseFormGroup.get('RelatedVatRecordOutOfSystem').updateValueAndValidity();
            break;
          }
          case 1 || 3:{
            this.baseFormGroup.get('RelatedInvoiceIssueDateFrom').setValue(null);
            this.baseFormGroup.get('RelatedInvoiceIssueDateFrom').updateValueAndValidity();
            this.baseFormGroup.get('RelatedInvoiceIssueDateTo').setValue(null);
            this.baseFormGroup.get('RelatedInvoiceIssueDateTo').updateValueAndValidity();         
            break;
          }
          case 2:{
            this.baseFormGroup.get('RelatedVatRecords').setValue(null);
            this.baseFormGroup.get('RelatedVatRecords').updateValueAndValidity();
            this.baseFormGroup.get('RelatedVatRecordOutOfSystem').setValue(null);
            this.baseFormGroup.get('RelatedVatRecordOutOfSystem').updateValueAndValidity();
            break;
          }
        }
      //}
      

    }      
    else{
      this.vrednostPovezanogDokumenta =  null;  
      this.baseFormGroup.get('RelatedInvoiceIssueDateFrom').setValue(null);
      this.baseFormGroup.get('RelatedInvoiceIssueDateFrom').updateValueAndValidity();
      this.baseFormGroup.get('RelatedInvoiceIssueDateTo').setValue(null);
      this.baseFormGroup.get('RelatedInvoiceIssueDateTo').updateValueAndValidity();
      this.baseFormGroup.get('RelatedVatRecords').setValue(null);
      this.baseFormGroup.get('RelatedVatRecords').updateValueAndValidity();
      this.baseFormGroup.get('RelatedVatRecordOutOfSystem').setValue(null);
      this.baseFormGroup.get('RelatedVatRecordOutOfSystem').updateValueAndValidity();
    }
      
   
  }

  onPeriodSelect(value:Period){
    if (value){
      let godina : number = Number(this.baseFormGroup.get('Godina').value);
      let poreskiPeriodId : number = Number(this.baseFormGroup.get('PoreskiPeriodId').value);
      let periodId : number = Number(value.ID);
      let brojPovezanogDokumenta = this.baseFormGroup.get('BrojPovezanogDokumenta').value;
      let tipDokumenta = this.tipDokumentaGenericName
      if (this.Item.ID == -1 && ((godina >= 2024 && poreskiPeriodId==1 && periodId>=9) || (godina >= 2024 && poreskiPeriodId==2 && periodId>=15) || godina > 2024 )){
        this.baseFormGroup.get('RelatedInvoiceOption').setValue(0);
        this.baseFormGroup.get('RelatedInvoiceOption').updateValueAndValidity();
        if (tipDokumenta == "Invoice" && brojPovezanogDokumenta)
        {
          this.baseFormGroup.get('RelatedInvoiceOption').setValue(3);
          this.baseFormGroup.get('RelatedInvoiceOption').updateValueAndValidity();
        }
       
        if (tipDokumenta == "CreditNote" || tipDokumenta == "DebitNote")
          {
            if (this.brojDokumenta){
              this.baseFormGroup.get('RelatedInvoiceOption').setValue(1);
              this.baseFormGroup.get('RelatedInvoiceOption').updateValueAndValidity();

              this.baseFormGroup.get('RelatedDocuments').setValue(this.brojDokumenta);
              this.baseFormGroup.get('RelatedDocuments').updateValueAndValidity();
            }

            if (this.datumPrometaOd && this.datumPrometaDo){
              this.baseFormGroup.get('RelatedInvoiceOption').setValue(2);
              this.baseFormGroup.get('RelatedInvoiceOption').updateValueAndValidity();

              this.baseFormGroup.get('RelatedInvoiceIssueDateFrom').setValue(this.datumPrometaOd);
              this.baseFormGroup.get('RelatedInvoiceIssueDateFrom').updateValueAndValidity();

              this.baseFormGroup.get('RelatedInvoiceIssueDateTo').setValue(this.datumPrometaDo);
              this.baseFormGroup.get('RelatedInvoiceIssueDateTo').updateValueAndValidity();
            }
          }

        // this.baseFormGroup.get('RelatedVatRecords').setValue(brojPovezanogDokumenta);
        // this.baseFormGroup.get('RelatedVatRecords').updateValueAndValidity();
      }
    }
  }
  //  Reset(loadItem: boolean = false): Observable<boolean>{
  //   this.SavedItem = this.baseFormGroup.getRawValue();
  //   this.baseFormGroup.patchValue({ PravacDokumentaId: 1 });
  //   this.baseFormGroup.get("PravacDokumentaId").updateValueAndValidity();

  //   let dateNow = new Date();
  //   let date: NgbDate = new NgbDate(
  //     dateNow.getFullYear(),
  //     dateNow.getMonth() + 1,
  //     dateNow.getDate()
  //   );

  //   this.baseFormGroup.patchValue({ DatumObracuna: date });
  //   this.baseFormGroup.get("DatumObracuna").updateValueAndValidity();

  //   super.Reset(loadItem);
  //   return of(true)
  //  }

  onRestoreClick(): void {
    this.Reset(true).subscribe((result) => {
        if (result) {
            // console.log('Restore successfully executed');
        } else {
            // console.log('Restore was cancelled by the user');
        }
    });
}

}

function compareNgbDates(d1: NgbDate, d2: NgbDate): boolean  {
  return d1.year === d2.year && d1.month === d2.month && d1.day === d2.day;
}

function checkPovezaniDokumenti(povezaniDokumenti: string, mainThis: any){
  return (group: FormGroup): { [key: string]: any } | null => {
    const _povezaniDokumenti: number = group.get(povezaniDokumenti).value;
    const _povezaniSEF = mainThis.baseFormGroup.get('RelatedVatRecords').value;
    const _povezaniVanSEF = mainThis.baseFormGroup.get('RelatedVatRecordOutOfSystem').value;
    const _datumOd = mainThis.baseFormGroup.get('RelatedInvoiceIssueDateFrom').value;
    const _datumDo = mainThis.baseFormGroup.get('RelatedInvoiceIssueDateTo').value;
    if (_povezaniDokumenti){   
        if ((_povezaniDokumenti==1 || _povezaniDokumenti==3) && (_povezaniSEF == null || _povezaniSEF == '')  && (_povezaniVanSEF == null || _povezaniVanSEF == ''))
            return {
              checkPovezaniDokumenti: {
                valid: false,
                message: 'Mora se uneti broj povezanog dokumenta u jedno od dva predviđena polja.'
              }
            };
        
        if (_povezaniDokumenti==2 && (_datumOd == null || _datumOd == '' || _datumDo == null || _datumDo == ''))
          return {
            checkPovezaniDokumenti: {
              valid: false,
              message: 'Mora se uneti datum od i datum do.'
            }
          };
      
  }
  else
    return null;
  }
}
